export const ADMIN_ROUTE_PERMISSION_MAP = {
  "/admin": "dashboard.view",
  "/admin/providers": "providers.view",
  "/admin/users": "players.view",
  "/admin/bookings": "bookings.view",
  "/admin/venues": "providers.view",
  "/admin/login-logs": "audit.logs.view",
  "/admin/platform-logs": "audit.logs.view",
  "/admin/revenue": "payments.view",
  "/admin/subscriptions": "payments.view",
  "/admin/cfo": "finance.console.view",
  "/admin/finance": "finance.console.view",
  "/admin/recruitment": "recruitment.view",
  "/admin/coordinators": "coordinators.view",
  "/admin/alerts": "audit.logs.view",
  "/admin/kyc-review": "kyc.review.view",
  "/admin/venue-verification": "venue.approvals.view",
  "/admin/staff-users": "staff.users.manage",
  "/admin/rbac-roles": "rbac.roles.manage",
  "/admin/checker-pools": "rbac.roles.manage",
  "/admin/approval-queue": "dashboard.view",
  "/admin/approval-history": "dashboard.view",
  "/admin/staff-manual": "dashboard.view",
};

export function hasBackofficePermission(user, permission) {
  const permissions = new Set(user?.backoffice_permissions || []);
  return permissions.has("*") || permissions.has(permission);
}

export function canAccessAdminPath(user, path) {
  if (user?.role === "PLATFORM_ADMIN") return true;
  if (user?.role !== "BACKOFFICE" || user?.staff_status !== "active") return false;
  const permission = Object.entries(ADMIN_ROUTE_PERMISSION_MAP)
    .sort((a, b) => b[0].length - a[0].length)
    .find(([prefix]) => path.startsWith(prefix))?.[1];
  return permission ? hasBackofficePermission(user, permission) : false;
}